import script from "./CropIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CropIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__